import React from 'react';

// Components
import EmptyStateCard from '@/views/components/misc/EmptyStateCard';

// Utils
import { BMOi18n } from '@/utils/bmo-gif/constants';

type BMOGIFEmptyStateProps = {
  locale: string;
  openEditBMOContactModal: () => void;
  showSelectContactModal: () => void;
};

const BMOGIFEmptyState: React.FC<BMOGIFEmptyStateProps> = ({ locale, openEditBMOContactModal, showSelectContactModal }) => {
  const primaryButton = { label: BMOi18n[locale].CREATE_CLIENT, onClick: openEditBMOContactModal };
  const secondaryLink = { label: BMOi18n[locale].SELECT_CLIENT, onClick: showSelectContactModal };

  return (
    <EmptyStateCard
      messagePath={BMOi18n[locale].EMPTY_STATE.DESCRIPTION}
      primaryButton={primaryButton}
      titlePath={BMOi18n[locale].EMPTY_STATE.TITLE}
      links={[secondaryLink]}
    />
  );
};

export default BMOGIFEmptyState;
